module.exports = __webpack_public_path__ + "img/MemeETC (20).94d0e08b.jpeg";